// A chip's value. Kept to primitives (incl. null for an "All" option) so the
// component stays generic enough to promote into Circuit unchanged.
export type ChipValue = string | number | null;

export interface ChipOption {
  label: string;
  value: ChipValue;
}

// SectionNavRail item. `to` is deliberately untyped (route location shape
// belongs to the consumer's router — the package has no vue-router dep);
// it only renders when the consumer also passes `linkComponent`.
export interface SectionNavItem {
  key: string;
  label: string;
  /** Icon class (e.g. `pi pi-bell`). Omit for text-only rails. */
  icon?: string;
  to?: unknown;
  href?: string;
}

export interface SectionNavGroup {
  /** Uppercase caption above the group. Omit for a flat, label-less rail. */
  label?: string;
  items: SectionNavItem[];
}

export const RunningDotVariant = {
  Active: 'active',
  Live: 'live',
} as const;

export type RunningDotVariantValue = typeof RunningDotVariant[keyof typeof RunningDotVariant];
